<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<form id="FormAccion" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7 pl-0">#</th>
                                    <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7 col-6 pl-0">Descripción</th>
                                    <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7 pl-0">Cantidad</th>
                                    <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7 pl-0">Precio</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in ListaAccion" :key="index">
                                    <td>{{(index+1)}}</td>
                                    <td width="45%">
                                        <textarea v-model="item.Descripcion" class="form-control" rows="2"></textarea>
                                    </td>
                                    <td>
                                        <input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');" class="form-control"/>
                                    </td>
                                    <td>
                                        <div class="money">
                                            <input type="text" v-model="item.Precio" @input="$number_decimal($event,item,'Precio');" class="form-control text-end"/>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" @click="EliminarElemento(index)" class="btn btn-link text-danger text-gradient px-3 mb-0">
                                            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>Eliminar
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                            
                        <br>
                    </div><!--fin col-12-->
                </div>
			</form>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormAccion',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ListaAccion: [],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0;
            this.poBtnSave.DisableBtn = true;

            if(this.ListaAccion.length==0){
                this.$toast.warning('Debe agregar al menos un elemento');
                this.poBtnSave.DisableBtn = false;
                return false;
            }

            let band1 = 0;
            let msg1 = '';

			$.each(this.ListaAccion, function(key, value){
                if(value.Descripcion == ''){
                    msg1 = "El campo Descripción de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.Cantidad == ''){
                    msg1 = "El campo Cantidad de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.Precio == ''){
                    msg1 = "El campo Precio de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); this.poBtnSave.DisableBtn = false; return false; }

			this.poBtnSave.DisableBtn = false;
            this.bus.$emit('SetearDescripcion',this.ListaAccion);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Limpiar()
        {
            this.ListaAccion = [];
            this.errorvalidacion = [];
        },
        SetearElemento()
        {
            let newObj = {
                Nomimagen: '',
				Descripcion: '',
                Cantidad: '',
                Precio: '',

                IdDetalleCotizacion: 0,
                IdCotizacionEvento: 0,
                IdImagenCopia: 0,
                IdBancoImagen: 0,
                DescripcionIngles: '',
                Notas: '',
                TotalIndividual: '',
                Moneda: '',
                Anexado: 0,
                TipoMoneda: 'MXN',
                FYM: '',
                EstiloIng: false,
                EstiloEsp: true,
                EstiloNot: false,
                UrlImagen: '',
            };

            this.ListaAccion.push(newObj);
        },
        EliminarElemento(index){
            this.ListaAccion.splice(index, 1);
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            this.ConfigLoad.ShowLoader = false;

            this.bus.$off('AgregarFilaDescripcion');
            this.bus.$on('AgregarFilaDescripcion',()=>
            {
                this.SetearElemento();
            });
        });
    }
}
</script>
